<template>
  <div class="InfoWindow">
    <div class="CloseIcon" @click="CloseInfoWindow()">
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.375 2.625L2.625 9.375" stroke="#0A1D29" stroke-width="1.5" stroke-linecap="square"/>
        <path d="M9.375 9.375L2.625 2.625" stroke="#0A1D29" stroke-width="1.5" stroke-linecap="square"/>
      </svg>
    </div>
    <h2>{{ article.article.title }}</h2>
    <div class="SummaryProducts_Info" v-if="theItems.length > 0">
      <lingallery  :leftControlClass="'leftGalleryDesign'" :rightControlClass="'rightGalleryDesign'" :iid.sync="currentId" :width="width" :height="height" :items="theItems" responsive="true"/>
    </div>

    <div class="description">
      {{ article.article.desc }}
    </div>
  </div>
</template>

<script>
import Lingallery from 'lingallery';

export default {
  name: "InfoWindow",
  data() {
    return {
      width: 'auto',
      height: 300,
      currentId: null,
      theItems:[]
    };
  },
  computed: {

    article() {
      return this.$store.state.infoArticle
    }
  },
  components: {
    Lingallery
  },
  methods: {
    items(){
      if(this.article.article.image !== false){
        this.theItems.push({
          src:this.article.article.image,
          thumbnail:this.article.article.image,
        })
      }
      if(this.$store.state.infoArticle.article.gallery !== undefined && this.$store.state.infoArticle.article.gallery !== null){
        Array.from(this.$store.state.infoArticle.article.gallery).forEach(x=>{
          this.theItems.push({
            src:x,
            thumbnail:x,
          })
        })
      }
    },
    CloseInfoWindow() {
      this.$store.commit('closeInfoWindow')
    }
  },
  mounted() {
    this.items()
  }
}
</script>
<style lang="scss">
#PrefabCreator{
  .InfoWindow{
    text-align: center;
    img{
      width: 100%;
      object-fit: contain;
      border: unset!important;
      padding: 5px;
    }
    .lingallery_thumbnails_content{
      max-width: 100%;
      padding-top: 10px;
      overflow: hidden!important;
      &::-webkit-scrollbar{
        display: none!important;
      }
    }

  }

}
.lingallery {
  .lingallery_thumbnails_content{
    overflow-x: scroll;
    max-width: 323px;
  }
  figure{
    height: 300px!important;
    overflow: hidden;

    img{
      float: left;
      transition: transform 0.4s ease;
      transform-origin: 50% 50%;

    }
    a{
      text-decoration: unset!important;
    }
    .rightGalleryDesign
    {
      padding-left: unset!important;
      padding-right: unset!important;
      text-shadow: unset!important;
      background: transparent!important;
      border: 1px solid black!important;
      box-shadow: 0px 0.6px 0.6px rgba(0, 0, 0, 0.1);
      border-radius: 50px;
      width: 34px;
      height: 34px!important;
      color: black!important;
      display: flex!important;
      align-items: center!important;
      justify-content: center!important;
      cursor: pointer!important;
      top: calc(50% - 12px) !important;
      font-size: 16px!important;
      &:hover{
        border: 2px solid black!important;
      }
      &::after{
        font-size: 16px!important;
        content: "\e907";
        font-family: 'icomoon' !important;
        position: relative;
      }
    }
    .leftGalleryDesign
    {
      padding-left: unset!important;
      padding-right: unset!important;
      text-shadow: unset!important;
      background: transparent!important;
      border: 1px solid black!important;
      box-shadow: 0px 0.6px 0.6px rgba(0, 0, 0, 0.1);
      border-radius: 50px;
      width: 34px;
      height: 34px!important;
      color: black!important;
      display: flex!important;
      align-items: center!important;
      justify-content: center!important;
      cursor: pointer!important;
      top: calc(50% - 12px) !important;
      font-size: 16px!important;
      &:hover{
        border: 2px solid black!important;
      }
      &::after{
        rotate: 180deg;
        font-size: 16px!important;
        content: "\e907";
        font-family: 'icomoon' !important;
        position: relative;
      }
    }
  }
}
</style>
<style scoped lang="scss">

.InfoWindow {
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  transform: translateX(0px);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.13);
  -webkit-transition: 0.25s transform ease-in-out;
  padding: 30px;
  background-color: #FBFBFB;
  border-left: 1px solid var(--gray-05, #E8E8E8);
  z-index: 9999999;
  *::-webkit-scrollbar{
    display: none!important;
  }
  &.active {
    transform: translateX(0);
  }

  .CloseIcon {
    position: absolute;
    top: 10px;
    right: 20px;
    cursor: pointer;

    &:hover {
      svg path {
        stroke: #8d9499;
      }
    }
  }

  .SummaryProducts_Info {
    padding-top: 20px;
    padding-bottom: 20px;
    *::-webkit-scrollbar{
      display: none;
    }

    img {
      max-height: 400px;
      width: auto;
      border-radius: 5px;
      border: unset!important;
    }
  }
}
</style>
